export class MyDevice {
	public bios: string;
	public productNo: string;
	public sn: string;
	public subBrand: string;
	public family: string;
	public hardware: boolean;
	public disk: any;
	public memory: any;
	public processor: any;
	public sysupdate: any;
	public warranty: any;

}
